import { render, staticRenderFns } from "./CommunityMarker.vue?vue&type=template&id=3fc87066&scoped=true"
import script from "./CommunityMarker.vue?vue&type=script&lang=ts"
export * from "./CommunityMarker.vue?vue&type=script&lang=ts"
import style0 from "./CommunityMarker.vue?vue&type=style&index=0&id=3fc87066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc87066",
  null
  
)

export default component.exports